<script setup>

import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import AddBacklinkButton from "@/components/backlinks/partials/AddBacklinkButton.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const search = computed(() => store.getters['backlinks/search']);
const mode = computed({
  get: () => store.getters['backlinks/mode'],
  set: (value) => store.dispatch('backlinks/setMode', value)
});
const activeTab = computed(() => store.getters['backlinks/activeTab']);

const modeOptions = [
  { value: 'basic', label: 'Simple Mode' },
  { value: 'advanced', label: 'Advanced Mode' }
];

const onSearchInput = (value) => {
  store.dispatch('backlinks/setSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-center tw-py-8 tw-text-grey-dark">
    <div class="tw-col-span-2">
      <CustomMultiselect
        v-model="mode"
        :options="modeOptions"
        mode="single"
        :close-on-select="true"
        :can-deselect="false"
        :searchable="false"
      />
    </div>

    <div class="tw-col-span-4">
      <SearchInput
        v-model="search"
        placeholder="Search Backlink"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-6 tw-flex tw-items-center tw-justify-end">
      <DefaultButton
        variant="primary-inverted"
        as="a"
        target="_blank"
        class="py-2 px-4 !tw-border"
        :href="`/backlinks/export?tab=${activeTab}`"
        size="small"
        :class="{
          'tw-mr-8' : activeTab === 'live'
        }"
      >
        <span class="tw-font-semibold tw-antialiased">Export</span>
        <svg-vue
          icon="icons/download"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>

      <AddBacklinkButton
        v-if="activeTab === 'live'"
      />
    </div>
  </div>
</template>

